// extracted by mini-css-extract-plugin
export default {"divisionFormWidget":"CompanyWizardView_divisionFormWidget__JWFjS"};